import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelAccountsUseResolverErrorStatesEnum {
    GetTradingClientFailed = ErrorStateScheduleEnum.PanelAccountsUseResolverStatesStartIndex,
    TradingClientNotFound,
    CashAccountsNotFound,
    GetClientFailed,
    GetClientNotFound
}
